import { OrdersService } from "./../../modules/orders/orders.service";
import { Component, OnInit, Input } from "@angular/core";

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { PageService } from "app/services/page-service";
import { AuthService } from "app/services/auth.service";
import { Router } from "@angular/router";
import { LocalService } from "app/services/local.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-update-status",
  templateUrl: "./update-status.component.html",
})
export class UpdateStatusComponent implements OnInit {
  @Input() content: any;
  contentForm: FormGroup;

  statusLists = [];
  newstatusLists = [];
  submitted = false;
  loader = false;
  errorMessage = "";
  schedule: boolean;
  orderId = "";
  orderdetaills: any;
  orderDetails: any = {};
  orderID = "";
  orderschedule: boolean;
  orderscheduled: boolean;
  riderOderstatus: any;
  ridercheck: any;

  constructor(
    public service: PageService,
    public orderservice: OrdersService,
    public authService: AuthService,
    public fb: FormBuilder,
    public router: Router,
    public localService: LocalService,
    public dialogRef: NgbActiveModal
  ) {}

  ngOnInit() {
    // console.log(this.content);
    this.statusLists = this.content['data'];
    
    this.contentForm = this.fb.group({
      // statusName : ['', Validators.required],
      // description  : ['',Validators.required],
      // previous : [null],
      next: [null],
    });
    // console.log(this.contentForm)
    if (this.content["record"] && this.content["record"]["_id"]) {
      const recordData = this.content["record"];
      this.contentForm = this.fb.group({
        // statusName : [recordData['statusName'], Validators.required],
        // description  : [recordData['description'],Validators.required],
        // previous : [recordData['previous'] ? recordData['previous'] : null],
        next: [recordData["next"] ? recordData["next"] : null],
      });
    }
  }
  get f() {
    return this.contentForm.controls;
  }

  close() {
    this.dialogRef.close({ success: false });
  }
  onSubmit() {
    // console.log(this.content.title)

    this.submitted = true;
    if (this.contentForm.invalid) {
      // console.log('error')
      return;
    }
    this.loader = true;
    const orderStatusJson = {
      orderID: this.content.orderid,
      status: this.contentForm.value["next"],
    };
    const orderTimelineJson = {
      orderTimeline: orderStatusJson,
    };

    if (this.content.orderid) {
      // const status = {
      //     orderDetails : {
      //       status : this.contentForm.value['next']
      //     }
      //   }
      //   this.service.updateOrderDetails(this.content.orderid,status).then(data =>{

      //     this.dialogRef.close({ success: true })
      // }).catch(err => {
      //     this.loader = false;
      //     this.errorMessage = 'Unable to update status';
      // });
      this.orderservice
        .createOrderTimeline(orderTimelineJson)
        .then((response) => {
          this.loader = false;
          this.dialogRef.close({ success: true });
        })
        .catch((err) => {
          this.loader = false;
          this.errorMessage = "Unable to update status";
        });
    }
    // else{
    //     this.service.createOrderStatus(orderStatusJson).then(response =>{
    //         this.loader = false;

    //         this.dialogRef.close({ success: true })
    //     }).catch(err => {
    //         this.loader = false;

    //         this.errorMessage = 'Unable to create status';
    //     });

    // }
  }
}
